var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2039 10.7039L21.3058 13.5145L18.3641 10.7039H0V24H34.3689V10.7039H24.2039ZM31.9078 22.0048H2.67961V13.3835H17.5631L21.3058 16.9806L25.0049 13.3835H31.8932L31.9078 22.0048Z",
    fill: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2966 1.57294V0.145752H6.74316V9.62634H8.40336V5.40303H12.6995V4.04867H8.41792V1.57294H13.2966Z",
    fill: "#CD2A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 6.08738V0H19.2958V6.10194H16.2812L21.291 10.7039L26.3007 6.10194H23.2861V6.08738Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForce);
export default __webpack_public_path__ + "static/media/force.034497ec4ba0118d69743a7d295faacb.svg";
export { ForwardRef as ReactComponent };